<template>
    <el-dialog
        class="supplier_quit_dialog"
        title="供应商退出"
        :visible.sync="openQuitDialog"
        top="4%"
        width="600px"
        :before-close="closeDialog">
        <div class="dialog_body">
            <el-row>
                <el-col :span="12">
                    <div>
                        <span class="title">供应商编码&nbsp;&nbsp;</span>
                        <span class="content">{{ row.supplierCode }}</span>
                    </div>
                </el-col>
                <el-col :span="12">
                    <div>
                        <span class="title">供应商名称&nbsp;&nbsp;</span>
                        <span class="content">{{ row.supplierNameCn }}</span>
                    </div>
                </el-col>
            </el-row>
            <el-row class="multiple_type_row">
                <el-col :span="12">
                    <div>
                        <span class="title">供应商类型&nbsp;&nbsp;</span>
                        <span class="content">{{ row.supplierType_ }}</span>
                    </div>
                </el-col>

                <el-col :span="12" class="quit-business-type_col">
                    <div>
                        <span class="title">退出业务类型&nbsp;&nbsp;</span>
                        <span class="content">{{ row.businessType_ }}</span>
                    </div>
                </el-col>
            </el-row>
            <el-form ref="form" :model="form" :rules="rules" label-width="70px" size="mini" style="font-size: 14px;">
                <el-row class="memo">
                    <el-col :span="11">
                        <el-form-item label="退出类型" prop="quitType">
                            <m-Select :optionNum="'SU_QUIT_TYPE'" :flag="'quitType'" :value="form.quitType" :filterable="true"  @input="getQuitType"></m-Select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="11" style="margin-left: 39px">
                        <el-form-item label="退出原因" prop="quitReason">
                            <m-Select :optionNum="'SRM_SU_QUIT_REASON'" :flag="'quitReason'" :value="form.quitReason" :filterable="true"  @input="getQuitReason"></m-Select>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row class="memo">
                    <el-col :span="24">
                        <el-form-item label="备注" prop="memo">
                            <el-input v-model="form.memo"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row class="memo">
                    <el-col :span="24">
                        <el-form-item label="附件上传" prop="fileName" class="upload_item">
                            <el-input v-model="form.fileName" placeholder="点击上传附件"></el-input>
                            <register-upload :uploadDisplayType="uploadDisplayType" class="upload_item_icon" :flag="'fileName'" @uploadSuccess="uploadSuccess"></register-upload>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row class="memo" v-if="quitTipVisible">
                    <el-col :span="24">
                        <el-form-item prop="quitTip">
                            <el-checkbox v-model="form.quitTip" true-label="1" false-label="">{{ tipType }}退出需一年后才能重新引入</el-checkbox>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
        </div>
        <span slot="footer" class="dialog-footer">
    <el-button @click="closeDialog">取 消</el-button>
    <el-button type="primary" :loading="loading" @click="confirmDialog">保 存</el-button>
  </span>
    </el-dialog>
</template>

<script>
import { mapGetters } from 'vuex';
// import { dictWithUrl } from '../../../../api/dict';
import { saveQuitSupplier, createQuitDraftProcess } from '../../../../api/register/supplierList';
import registerUpload from '../../../../components/upload/Index';
import mSelect from '../../../../components/Select';
import { FD_TEMPLATE_CODE, QUIT_TYPE } from '../../../../constant/constant';

export default {
    name: 'supplier-quit-dialog',
    components: { mSelect, registerUpload },
    props: {
        openQuitDialog: {
            type: Boolean,
            default() {
                return false;
            }
        },
        row: {
            type: Object,
            default() {
                return {};
            }
        },
        formData: {
            type: Object,
            default() {
                return {};
            }
        }
    },
    data() {
        return {
            uploadDisplayType: 'icon',
            form: {
                quitType: '',
                quitReason: '',
                memo: '',
                fileName: '',
                fileUrl: '',
                quitTip: '' // 只需提示用户勾选，不需传参至接口
            },
            rules: {
                quitType: [
                    { required: true, message: '请选择退出类型', trigger: ['blur', 'change'] }
                ],
                quitReason: [
                    { required: true, message: '请选择退出原因', trigger: ['blur', 'change'] }
                ],
                quitTip: [
                    { required: true, message: '请勾选确认提示', trigger: ['blur', 'change'] }
                ]
            },
            dict: {},
            loading: false
        };
    },
    computed: {
        ...mapGetters(['currentTenant', 'applicationCode']),
        // 当前用户usercode
        loginName() {
            return this.$store.state.user.userCode;
        },
        // 主动、被动退出时显示
        quitTipVisible() {
            return [QUIT_TYPE.ACTIVE, QUIT_TYPE.PASSIVE].includes(this.form.quitType);
        },
        tipType() {
            return QUIT_TYPE.ACTIVE === this.form.quitType ? '主动' : '被动';
        }
    },
    methods: {
        getQuitType(data) {
            this.$set(this.form, 'quitType', data);
            this.$set(this.form, 'quitTip', '');
        },
        getQuitReason(data) {
            this.$set(this.form, 'quitReason', data);
        },
        closeDialog() {
            this.$emit('closeDialog', false);
            this.clear();
        },
        confirmDialog() {
            this.$refs['form'].validate().then(async res => {
                const { id, supplierCode, supplierNameCn, isOverseas, businessType, businessTypeId, supplierReinsertFlag, businessReinsertFlag } = this.row;
                const formParams = {
                    ...this.form,
                    supplierCode,
                    supplierName: supplierNameCn,
                    quitServiceType: businessType,
                    businessTypeId,
                    id: id || null
                };
                delete formParams.quitTip;

                this.loading = true;
                const saveQuitRes = await saveQuitSupplier(formParams);

                if (!saveQuitRes) {
                    this.loading = false;
                    return false;
                }

                const mipFormId = saveQuitRes.data;
                const fdUrl = location.origin + location.pathname + `#/keyData/mipMessage?mipFormId=${mipFormId}&reviewType=quit`;
                const mipParams = {
                    supplierCode,
                    isOverseas,
                    businessType,
                    supplierReinsertFlag,
                    businessReinsertFlag,
                    tenantCode: this.currentTenant.tenantCode,
                    appCode: this.applicationCode,
                    loginName: this.loginName,
                    // fdTemplateId: FD_TEMPLATE_ID.QUIT,
                    fdTemplateCode: FD_TEMPLATE_CODE.QUIT,
                    formParam: {
                        formData: null,
                        subject: `供应商退出审批流程-${supplierCode}`,
                        formInstanceId: mipFormId,
                        fdUrl
                    }
                };
                this.loading = true;
                const processRes = await createQuitDraftProcess(mipParams);
                this.loading = false;
                if (processRes && processRes.data) {
                    this.closeDialog();
                    const { fdId, formId } = processRes.data;
                    this.$router.push({
                        name: 'mipIframe',
                        query: {
                            processId: fdId,
                            formInstanceId: formId,
                            path: '/keyData'
                        }
                    });
                }
            });
        },
        uploadSuccess(data) {
            this.form.fileId = data.data.data.id;
            this.form.fileName = data.data.data.localFileName;
            this.form.fileUrl = data.data.data.downUrl;
        },
        clear() {
            this.contract = '';
            this.form = {
                quitType: '',
                quitReason: '',
                memo: '',
                fileName: '',
                fileUrl: '',
                quitTip: ''
            };
        }
    },
    watch: {
        formData(val) {
            if (val) {
                this.form = { ...val };
            }
        }
    }
};
</script>

<style lang="less">
    .supplier_quit_dialog {
        .dialog_body {
            padding: 20px 50px;
            box-sizing: border-box;
            width: 100%;
            // height: 200px;
            .el-form-item__label {
                text-align: left;
            }
            .el-row {
                margin-bottom: 15px;
            }
            .multiple_type_row {
                margin-bottom: 0;
                .el-col {
                    margin-bottom: 15px;
                }
            }
            .upload_item {
                position: relative;
                .upload_item_icon {
                    width: 291.19px;
                    height: 28px;
                    font-size: 16px;
                    color: #33c9cc;
                    position: absolute;
                    top: 2px;
                }
                .upload-demo {
                    width: 100%;
                    height: 28px;
                }
                .el-input {
                    width: 291.19px;
                }
            }
            .el-upload {
                width: 100%;
                height: 28px;
                text-align: right;
                padding-right: 6px;
                box-sizing: border-box;
            }
            .title {
                color: #666;
            }
            .memo {
                margin-bottom: 0;
            }
        }

    }
</style>
